// This is a part of the Cadcorp SIS source code. 
// Copyright (c) Cadcorp Limited 1991-2026 
/**
* Copy all properties of a source object to a destination object.  Modifies
*     the passed in destination object.  Any properties on the source object
*     that are set to undefined will not be (re)set on the destination object.
* @function Cadcorp.Util.extend
*
* @param {object} destination The object that will be modified
* @param {object} source The object with properties to be set on the destination
*
* @returns {object} The destination object.
*/
export function extend (destination : object, source : object):object {
    destination = destination || {};
    if (source) {
        for (var property in source) {
            var value = source[property];
            if (value !== undefined) {
                destination[property] = value;
            }
        }

        var sourceIsEvt = typeof window.event === 'function'
            && source instanceof window.event;

        if (!sourceIsEvt
            && source.hasOwnProperty && source.hasOwnProperty('toString')) {
            destination.toString = source.toString;
        }
    }
    return destination;
};

/**
 * Hides our loading element
 * @funciton
 */
export function hideLoading() {
    var loadingMask = document.getElementById('loadingMask');
    loadingMask.addEventListener('animationend', function () {
        loadingMask.classList.add('display-none');
    });
    loadingMask.classList.add('loadingDisplay-none');
}
/**
 * Removes invalid characters from a string. The only valid characters are a-z and the numbers 0-9
 * @param {string} name The javascript name to have invalid characters removed
 */
const validRegex = /([^a-z0-9]+)/gi;
export function removeInvalidJavascriptChars(name: string): string {
    return name.replace(validRegex, '_');
}
/**
 * Adds parameters from the param object to the url
 * @param {string} uri The url to append the parameters to
 * @param {object} params The object containing the parameters
 * @return {string} The url with the parameter
 */
export function appendParameters(uri : string, params: any): string {
    const keyParams: string[] = [];
    // Skip any null or undefined parameter values
    Object.keys(params).forEach(function (k) {
        if (params[k] !== null && params[k] !== undefined) {
            keyParams.push(k + '=' + encodeURIComponent(params[k]));
        }
    });
    const qs = keyParams.join('&');
    // remove any trailing ? or &
    uri = uri.replace(/[?&]$/, '');
    // append ? or & depending on whether uri has existing parameters
    uri = uri.indexOf('?') === -1 ? uri + '?' : uri + '&';
    return uri + qs;
};

/**
* Formats a date object 
* @function
* @param {Date} date - The date to get the format for
* @returns {string} The formatted date
*/
export function formatDate(date: any): string {
    return date.toLocaleString(undefined, { timeZone: 'UTC', dateStyle: 'short', timeStyle: 'short' });
};

import { ISchemaColumn } from '../../../../CommonScripts/Abstractions';
import {isDate } from './validation';
/**
 * Returns a nicely formatted string
 * @param value
 * @param 
 */
export function formatValue(value: any, schemaColumn?: ISchemaColumn): string {
    if (value == undefined || value == null) return null;    
    if (schemaColumn) return formatValueFromSchema(value, schemaColumn);    
    switch (typeof value) {
        case 'string':
            const numericReg = /^-?\d*\.?\d*$/;
            if (numericReg.test(value)) return value.toString();
            else if (isDate(value) !== true) return value;
            else {
                const tmpDate: Date = new Date(value);
                return formatDate(tmpDate);
            }            
        case 'object':
            const property = value[Object.keys(value)[0]];
            return formatValue(property);            
        case 'number':
        case 'boolean':
        default: return value.toString();            
    }      
}
function formatValueFromSchema(value: any, schemaColumn: ISchemaColumn): string {
    let retVal: string = null;
    switch (schemaColumn.type) {
        case 7: //date
            const val = value[schemaColumn.typeName];
            let tmpDate: Date = new Date(val);
            retVal = formatDate(tmpDate);
            break;
        case 8: //string $ type columns
            retVal =value;
            break;
        case 11: //boolean
        // numeric types that are actually returned as numbers from geognosis
        case 5: //numeric # type column
        case 3: //integer type column & suffix
            retVal = value.toString();
            break;
        case 2: //short int
        case 4: //single type
        case 6: //currency
        case 18://unsigned short
        case 16://byte
        case 17://unsigned byte
            retVal = value[schemaColumn.typeName]?.toString();
            break;
        // numeric types that are actually returned as strings from geognosis so filtering will be limited to equals
        case 19: //Unsigned long
        case 20: //Long Long int
        case 21: //Unsigned long long
        case 14://decimal
            retVal = value[schemaColumn.typeName];
            break;
        default: //anything we don't know about is not allowed
            retVal = value.toString();
            break;
    }
    return retVal;
}
/**
 * Generates a string containing random hex characters
 * @param {number} length The length of the required string
 */
export function generateRandomHex(length): string {
    return [...Array(length)].map(() => Math.floor(Math.random() * 16).toString(16)).join('');
}

